<template>
    <div id="bloco-inserir-territorio-certificacao-planilha">
        <h1>{{ $tc('certification.messages.insert_territory_data') }}</h1>
        <el-card>
            <div class="box-card-inserir-territorio-planilha">
                <div class="box-card-inserir-territorio-planilha__conteudo">
                    <div
                        class="box-card-inserir-territorio-planilha__conteudo__bloco"
                    >
                        <span>
                            {{
                                $tc(
                                    'certification.messages.instruction_add_properties_via_spreadsheet'
                                )
                            }}
                            <br />
                            {{
                                $tc(
                                    'certification.messages.instruction_must_contain_fields'
                                )
                            }}
                        </span>
                    </div>
                    <div
                        class="box-card-inserir-territorio-planilha__conteudo__bloco"
                    >
                        <div
                            class="box-card-inserir-territorio-planilha__conteudo__bloco__lista"
                        >
                            <ul>
                                <li class="required-field">
                                    {{ $tc('certification.words.territory') }}
                                </li>
                                <li class="required-field">
                                    {{ $tc('certification.words.car') }}
                                </li>
                                <li>{{ $tc('certification.words.person') }}</li>
                                <li>CPF/CNPJ</li>
                            </ul>
                        </div>
                    </div>
                    <div
                        class="box-card-inserir-territorio-planilha__conteudo__bloco"
                    >
                        <div
                            class="box-card-inserir-territorio-planilha__conteudo__bloco__buttons"
                        >
                            <span
                                class="btn-download"
                                @click="downloadPlanilhaExemplo"
                            >
                                <i class="mdi mdi-download"></i>
                                <span>{{
                                    $tc(
                                        'certification.messages.download_spreadsheet_template'
                                    )
                                }}</span>
                            </span>
                            <el-upload
                                class="upload-demo"
                                action="#"
                                :auto-upload="false"
                                :show-file-list="false"
                                :on-change="enviarPlanilha"
                                :limit="1"
                                ref="uploadPlanilhaTerritorio"
                            >
                                <span>
                                    <el-button
                                        icon="el-icon-upload2"
                                        type="primary"
                                    >
                                        {{
                                            $tc(
                                                'certification.messages.insert_spreadsheet'
                                            )
                                        }}
                                    </el-button>
                                </span>
                            </el-upload>
                        </div>
                    </div>
                    <div v-if="dadosLote">
                        <hr />
                        <div
                            class="bloco-inserir-territorio-planilha-lote-importada"
                        >
                            <div
                                class="bloco-inserir-territorio-planilha-lote-importada_bloco"
                            >
                                <span
                                    class="bloco-inserir-territorio-planilha-lote__label"
                                >
                                    {{
                                        $tc(
                                            'certification.messages.spreadsheet_imported'
                                        )
                                    }}
                                </span>
                                <el-tooltip
                                    effect="dark"
                                    :content="dadosLote.planilha"
                                    placement="top"
                                >
                                    <span
                                        class="bloco-inserir-territorio-planilha-lote-importada_nome"
                                        >{{ dadosLote.planilha }}</span
                                    >
                                </el-tooltip>
                            </div>
                            <div
                                class="bloco-inserir-territorio-planilha-lote-importada_bloco"
                            >
                                <span
                                    class="bloco-inserir-territorio-planilha-lote__label"
                                >
                                    {{
                                        $tc(
                                            'certification.words.registration_date'
                                        )
                                    }}
                                </span>
                                <span
                                    class="bloco-inserir-territorio-planilha-lote-importada_data"
                                    >{{ dadosLote.dataCadastro }}</span
                                >
                            </div>
                            <div
                                class="bloco-inserir-territorio-planilha-lote-importada_bloco"
                                v-if="
                                    dadosLote.planilhaErro &&
                                    dadosLote.statusCodigo !== 'ERRO_PROCESSAR'
                                "
                            >
                                <span
                                    class="bloco-inserir-territorio-planilha-lote__label"
                                    >{{
                                        $tc(
                                            'certification.messages.spreadsheet_with_error'
                                        )
                                    }}</span
                                >
                                <el-button
                                    class="bloco-inserir-territorio-planilha-lote__button"
                                    type="primary"
                                    size="mini"
                                    icon="el-icon-download"
                                    @click="fazerDownload(dadosLote.id)"
                                >
                                    {{ $tc('certification.messages.download') }}
                                </el-button>
                            </div>
                            <div
                                class="bloco-inserir-territorio-planilha-lote-importada_bloco"
                            >
                                <span
                                    class="bloco-inserir-territorio-planilha-lote__label"
                                    >{{
                                        $tc('certification.words.status')
                                    }}</span
                                >
                                <el-tag
                                    class="bloco-inserir-territorio-planilha-lote__status"
                                    v-if="
                                        dadosLote.statusCodigo ===
                                        'EM_PROCESSAMENTO'
                                    "
                                    type="info"
                                    size="small"
                                >
                                    <i
                                        class="el-icon-loading"
                                        v-if="
                                            dadosLote.statusCodigo ===
                                            'EM_PROCESSAMENTO'
                                        "
                                    ></i>
                                    {{ dadosLote.status }}
                                </el-tag>
                                <el-tag
                                    class="bloco-inserir-territorio-planilha-lote__status"
                                    v-if="
                                        dadosLote.statusCodigo ===
                                        'PROCESSADO_COM_ERRO'
                                    "
                                    type="warning"
                                    size="small"
                                >
                                    {{ dadosLote.status }}
                                </el-tag>
                                <el-tag
                                    class="bloco-inserir-territorio-planilha-lote__status"
                                    v-if="
                                        dadosLote.statusCodigo === 'PROCESSADO'
                                    "
                                    type="success"
                                    size="small"
                                >
                                    {{ dadosLote.status }}
                                </el-tag>
                                <el-tag
                                    class="bloco-inserir-territorio-planilha-lote__status"
                                    v-if="
                                        dadosLote.statusCodigo ===
                                        'ERRO_PROCESSAR'
                                    "
                                    type="danger"
                                    size="small"
                                >
                                    {{ dadosLote.status }}
                                </el-tag>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <hr />
                        <br />
                        <p>
                            {{
                                $tc(
                                    'certification.messages.no_spreadsheet_sent_for_territory_insertion'
                                )
                            }}
                        </p>
                    </div>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import CertificacaoService from '@/services/CertificacaoService';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import { mapGetters } from 'vuex';

export default {
    name: 'BlocoInserirPlanilhaCertificacao',
    components: {},
    props: {
        territoriosNaoEnviados: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            fileList: [],
            dadosLote: null,
            dadosTabelaViaPlanilha: [],
            InserirPlanilhaCertificacaoTerritorioInput: []
        };
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    mounted() {
        this.buscarDadosLote();
        this.conectarCanalNotificacaoProcessamento();
    },
    beforeDestroy() {
        disconnect();
    },
    methods: {
        async buscarDadosLote() {
            try {
                const { data } = await CertificacaoService.buscarDadosLote();
                if (data) {
                    this.dadosLote = data;
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$tc(
                        'certification.messages.errors.error_fetching_processing_data'
                    )
                });
            }
        },

        async enviarPlanilha(planilha) {
            if (
                this.dadosLote &&
                this.dadosLote.statusCodigo === 'EM_PROCESSAMENTO'
            ) {
                this.$notify.warning({
                    message: this.$tc(
                        'certification.messages.errors.cannot_register_new_record_processing_in_progress'
                    )
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }

            if (planilha.size > 15000000) {
                this.$notify.warning({
                    message: this.$tc(
                        'certification.messages.errors.file_exceeds_15mb'
                    )
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }
            let extension = planilha.name.split('.').pop().toLowerCase();

            if (extension !== 'xlsx') {
                this.$notify.error({
                    message: this.$tc(
                        'certification.messages.errors.only_xlsx_files_supported'
                    )
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }

            try {
                this.$notify.success({
                    message: this.$tc(
                        'certification.messages.file_is_being_uploaded'
                    )
                });
                this.InserirPlanilhaCertificacaoTerritorioInput = [];

                this.territoriosNaoEnviados.forEach(territorio => {
                    const territorioConvertido = {
                        id: territorio.id,
                        nome: territorio.nome,
                        representantes: territorio.representantes,
                        geometrias: territorio.geometrias,
                        cars: territorio.cars,
                        viaPlanilha: territorio.viaPlanilha
                    };
                    this.InserirPlanilhaCertificacaoTerritorioInput.push(
                        territorioConvertido
                    );
                });

                const inserirPlanilhaCertificacaoTerritorioInputDados =
                    this.InserirPlanilhaCertificacaoTerritorioInput;

                await CertificacaoService.cadastrarViaPlanilha(planilha)
                    .then(({ data }) => {
                        this.processarPlanilhaEnviada(
                            data,
                            inserirPlanilhaCertificacaoTerritorioInputDados
                        );
                    })
                    .catch(() => {
                        this.$notify.error({
                            message: 'Erro ao realizar upload do arquivo.'
                        });
                    });
                this.$notify.success({
                    message: this.$tc(
                        'certification.messages.file_successfully_uploaded_processing_will_finish_soon'
                    )
                });

                this.buscarDadosLote();
            } catch (error) {
                this.$notify.error({
                    message: this.$tc(
                        'certification.messages.errors.error_uploading_file'
                    )
                });
            }
            this.$refs.uploadPlanilhaTerritorio.clearFiles();
        },

        async processarPlanilhaEnviada(valorId, certificacaoTerritorioJson) {
            await CertificacaoService.processarPlanilha(
                valorId,
                certificacaoTerritorioJson
            );
        },

        async conectarCanalNotificacaoProcessamento() {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$tc(
                        'certification.messages.errors.unable_to_connect_to_api'
                    )
                });
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/lote/certificacao-territorio/cadastro`,
                    response => {
                        this.dadosTabelaViaPlanilha = JSON.parse(response);
                        this.$notify.success({
                            message: this.$tc(
                                'certification.messages.processing_updated'
                            )
                        });
                        this.buscarDadosLote();
                        if (
                            this.dadosTabelaViaPlanilha.itens != null &&
                            this.dadosTabelaViaPlanilha.itens.length > 0
                        ) {
                            this.$emit(
                                'adicionarCertificacaoNaoEnviadaPlanilha',
                                this.dadosTabelaViaPlanilha
                            );
                        }
                    }
                );
            } catch (error) {
                this.$notify.error({
                    message: this.$tc(
                        'certification.messages.errors.unable_to_subscribe_to_websocket'
                    )
                });
                disconnect();
            }
        },

        downloadPlanilhaExemplo() {
            let link = document.createElement('a');
            link.setAttribute(
                'download',
                'planilha-exemplo-certificacao-territorio'
            );
            link.href =
                'https://lyra-bunge-publico.s3.amazonaws.com/planilha-exemplo-certificacao-territorio.xlsx';
            document.body.appendChild(link);
            link.click();
            link.remove();
        },

        fazerDownload(id) {
            CertificacaoService.downloadPlanilhaComErro(id)
                .then(() => {
                    this.$notify.success({
                        message: this.$tc(
                            'certification.messages.download_successful'
                        )
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$tc(
                            'certification.messages.error_downloading'
                        )
                    });
                });
        }
    }
};
</script>

<style lang="scss" scoped>
#bloco-inserir-territorio-certificacao-planilha {
    width: 100%;

    h1,
    ul {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
    }

    .lista {
        display: flex;
        flex-direction: row;
    }

    .el-card.is-always-shadow {
        min-height: 370px;
    }

    el-card {
        margin-top: 10px;
    }

    .box-card-inserir-territorio-planilha {
        height: 333px;
    }
    .box-card-inserir-territorio-planilha__conteudo {
        display: flex;
        flex-direction: column;
        min-height: 297px;
        justify-content: space-between;
        font-size: 16px;
        gap: 15px;

        .box-card-inserir-territorio-planilha__conteudo__bloco {
            display: flex;
            .box-card-inserir-territorio-planilha__conteudo__bloco__buttons {
                display: flex;
                gap: 15px;
                width: 100%;
                justify-content: flex-end;
                align-items: center;
                .btn-download {
                    cursor: pointer;
                    display: flex;
                    gap: 5px;
                    font-weight: 600;
                    i {
                        font-size: 15px;
                    }
                    span {
                        text-decoration: underline;
                        color: var(--primary);
                    }
                }
            }

            .box-card-inserir-territorio-planilha__conteudo__bloco__lista {
                ul {
                    margin-bottom: 15px;
                }

                li.required-field::after {
                    content: ' *';
                    color: #f56c6c;
                }
            }
        }
    }

    .bloco-inserir-territorio-planilha-lote-importada {
        display: flex;
        justify-content: space-between;

        .bloco-inserir-territorio-planilha-lote-importada_bloco {
            font-size: 12px;
            display: flex;
            flex-direction: column;
            gap: 5px;
            max-width: 34%;
        }

        .bloco-inserir-territorio-planilha-lote__label {
            font-weight: bold;
            color: var(--primary);
        }

        .bloco-inserir-territorio-planilha-lote-importada_nome {
            display: inline-block;
            width: 120px;
            font-size: 11px;
            white-space: nowrap;
            overflow: hidden !important;
            text-overflow: ellipsis;
            margin-top: 4px;
        }

        .bloco-inserir-territorio-lote__status {
            font-size: 11px;
        }
        .bloco-inserir-territorio-planilha-lote__button {
            font-size: 11px;
        }

        .bloco-inserir-territorio-planilha-lote-importada_data {
            display: inline-block;
            width: 100px;
            font-size: 11px;
            white-space: nowrap;
            overflow: hidden !important;
            text-overflow: ellipsis;
            margin-top: 4px;
        }
    }
}
</style>
